import brands from "@/styles/modules/brands.module.scss";
import VadImage from "vadimages-nextjs-image-optimizer";
import * as Api from '@api';

const pageSlug = "top-brands";

export const PageKeys = [
    "top.brands.title",
] as const;

export default async function TopBrands() {
    const pageContent = await Api.PageService.getBareContentBySlug(pageSlug, PageKeys);

    return (
        <section className={brands.trusted_brands}>
            <div className="container">
                <h3 className="h8 text-center">{pageContent["top.brands.title"]?.data ?? ""}</h3>
                <div className="flex flex-wrap justify-center items-center gap-10 md:gap-8 md:justify-between">
                    <figure className="flex-col">
                        <VadImage src="/images/brands/trusted-section/trulieve-color.png"
                                       width={152} height={55} alt="Trulieve"/>
                    </figure>
                    <figure className="flex-col">
                        <VadImage src="/images/brands/trusted-section/select-color.png"
                                       width={137} height={40} alt="Select"/>
                    </figure>
                    <figure className="flex-col">
                        <VadImage src="/images/brands/trusted-section/verano-color.png"
                                       width={140} height={23} alt="Verano"/>
                    </figure>
                    <figure className="flex-col">
                        <VadImage src="/images/brands/trusted-section/ayrloom-color.png"
                                       width={135} height={30} alt="Ayrloom"/>
                    </figure>
                    <figure className="flex-col">
                        <VadImage src="/images/brands/trusted-section/decibel-color.png"
                                       width={85} height={60} alt="Decibel"/>
                    </figure>
                </div>
            </div>
        </section>
    )
}